import {TableRow} from "@mui/material";
import {sx} from './sx'
import {FC, ReactNode} from "react";
import {SxType} from "@baseTypes/sx/sxTypes";

interface IProps{
    children:ReactNode,
    sx?:SxType,
    onClick?:()=>void,
    id?:string,
    className?:string,
}
const TrCustom:FC<IProps> = ({
                                 children,
                                 sx: sxProps = {}
                                 ,onClick,
                                 id,
                                 className}) => {
    return (
        <TableRow
            onClick={onClick}
            className={className}
            id={id}
            sx={{...sx, ...sxProps}}
        >
            {children}
        </TableRow>
    );
};

export default TrCustom;
